module.exports = __webpack_public_path__ + "img/image1.2482e194.png";